import { render, staticRenderFns } from "./InvestmentMetadataEditButtons.vue?vue&type=template&id=33ee43e1"
import script from "./InvestmentMetadataEditButtons.vue?vue&type=script&lang=js"
export * from "./InvestmentMetadataEditButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports